angular.module('impactx.cube').service('CubeService', CubeService);

CubeService.$inject = ['dataGen', 'CubeConfigService', '$mdToast', 'ToastService', 'cubeMenu'];

/**
 * Service for obtaining cube data
 * @param dataGen Data service
 * @param CubeConfigService Cube config service to obtain the configured cube
 * @param $mdToast Toast service to show successful actions
 * @param ToastService ix Toast service to show successful actions
 * @param cubeMenu the cube menu to refresh the stored cubes in sidebar.
 * @constructor
 */
function CubeService(dataGen, CubeConfigService, $mdToast, ToastService, cubeMenu) {
    var self = this;

    CubeConfigService.columnLevelDrillDownIndex = 0;
    CubeConfigService.rowLevelDrillDownIndex = 0;

    this.getPrintString = function getPrintString(vm) {
        var printString = '<div class="ix-flex">';
        var columnIndex = 0;
        var rowIndex = 0;

        if (vm.data.columns) {
            while (columnIndex < vm.data.columns.length) {
                var column = vm.data.columns[columnIndex];

                printString += '<div ' + (column.isHeaderColumn ? "class=\"HeaderColumn\" : " : "") + '>';
                while (rowIndex < column.Row.length) {
                    var row = column.Row[rowIndex];
                    var classStringCell = "CubeCell md-caption ix-flex";
                    if (row.IsData) {
                        classStringCell += " CubeCellValue";
                    }
                    if (row.IsLabel) {
                        classStringCell += " CubeCellHeader";
                    }
                    if (row.IsColumnHeader) {
                        classStringCell += " CubeCellColumnHeader";
                    }
                    if (row.IsRowHeader) {
                        classStringCell += " CubeCellRowHeader";
                    }
                    var clickString = "";
                    if ((row.IsColumnHeader || row.IsRowHeader) && row.Text && row.Text != ' ' &&
                        ((row.IsColumnHeader && (!vm.data.columns[columnIndex].Row[rowIndex + 1].Text || vm.data.columns[columnIndex].Row[rowIndex + 1].Text == ' ')) || (row.IsRowHeader && !row.IsMeasure))) {
                        clickString = ' ng-click="cubeCtrl.select(' + rowIndex +  ', ' + columnIndex + ', $event)"';
                    }
                    printString += '<div class="' + classStringCell + '" id="' + rowIndex + '.' + columnIndex + '" ' + clickString + '> ';

                    if (row.Text && row.Text != ' ') {
                        printString += '<span class="TopText">' + row.Text + '</span>';
                    }
                    if (row.Value) {
                        printString += row.Value;
                    }
                    if (row.Up) {
                        printString += '<div class="mdi mdi-chevron-up drill-up" ng-click="cubeCtrl.drillUp(' + rowIndex + ', ' + columnIndex + ', $event)"></div>'
                    }
                    if (row.Down) {
                        printString += '<div class="mdi mdi-chevron-down" ng-click="cubeCtrl.drillDown(' + rowIndex + ', ' + columnIndex + ', $event)"></div>'
                    }
                    printString += '</div>';
                    rowIndex++;
                }
                printString += '</div>';
                columnIndex++;
                rowIndex = 0;
            }
        }
        printString += '</div>';
        return printString;
    };

    /**
     * initialize the service by getting the data from the server
     * @param vm
     * @param id id of the stored cube.
     * @returns {*}
     */
    this.init = function (vm, id) {
        if (CubeConfigService.selectedCube) {
            CubeConfigService.selectedCube.rowLevelDrillDownIndex = CubeConfigService.rowLevelDrillDownIndex;
            CubeConfigService.selectedCube.columnLevelDrillDownIndex = CubeConfigService.columnLevelDrillDownIndex;
        }
        return dataGen.postAsForm(vm, {
            cube: CubeConfigService.selectedCube,
            id: id
        }, "/monitor/cube/get").then(function () {
            var configFromServer = vm.data.cube;
            if (configFromServer) {
                CubeConfigService.selectedCube = configFromServer;
            }
            var xbreak = false;
            var selectedCube = CubeConfigService.selectedCube;
            if (selectedCube && selectedCube.rows && !(selectedCube.rows.length > 1)) {
                angular.forEach(vm.data.columns, function (value, key) {
                    if (!xbreak) {
                        angular.forEach(value.Row, function (value2, key2) {
                            if (value2.Value || value2.IsMeasure) {
                                xbreak = true;
                            }
                        });
                        if (!xbreak && key != 0) {
                            value.isHeaderColumn = true;
                        }
                    }
                });
            }
            vm.printString = self.getPrintString(vm);
            vm.newData.value = true;
            vm.selectedCube = CubeConfigService.selectedCube;
        });
    };

    /**
     * Drilldown a column
     * @param vm View Model to update
     * @param row row to drilldown
     * @param column column to drill down
     * @param cell Cell to drilldown
     */
    this.drillDown = function (vm, row, column, cell) {
        var newDrillDowns = [];
        newDrillDowns.push({row: row, column: column, columnName: cell.Action, name: cell.Name, action: "DRILLDOWN"});
        CubeConfigService.selectedCube.newDrillDowns = newDrillDowns;
        this.init(vm);
    };

    /**
     * Drilldown a complete column level
     * @param vm View Model to update
     */
    this.drillDownColumnLevel = function (vm) {
        var newDrillDowns = [];
        newDrillDowns.push({row: 0, column: 0, columnName: "column", action: "DRILLDOWNLEVEL"});
        CubeConfigService.selectedCube.newDrillDowns = newDrillDowns;
        CubeConfigService.selectedCube.removeColumnLevelDrillDowns = false;
        CubeConfigService.columnLevelDrillDownIndex++;
        this.init(vm);
    };

    /**
     * Drilldown a complete row level
     * @param vm View Model to update
     */
    this.drillDownRowLevel = function (vm) {
        var newDrillDowns = [];
        newDrillDowns.push({row: 0, column: 0, rowName: "row", action: "DRILLDOWNLEVEL"});
        CubeConfigService.selectedCube.newDrillDowns = newDrillDowns;
        CubeConfigService.selectedCube.removeRowLevelDrillDowns = false;
        CubeConfigService.rowLevelDrillDownIndex++;
        this.init(vm);
    };

    /**
     * Remove a drilldown
     * @param vm View Model to update
     * @param row row to drillup
     * @param column column to drillup
     * @param cell Cell to drillup
     */
    this.drillUp = function (vm, row, column, cell) {
        var removeDrillDowns = [];
        removeDrillDowns.push({row: row, column: column, columnName: cell.Action, name: cell.Name});
        CubeConfigService.selectedCube.removeDrillDowns = removeDrillDowns;
        this.init(vm);
    };

    /**
     * Remove a complete column level drilldown
     * @param vm View Model to update
     */
    this.drillUpColumnLevel = function (vm) {
        CubeConfigService.selectedCube.removeColumnLevelDrillDowns = true;
        CubeConfigService.columnLevelDrillDownIndex--;
        this.init(vm);
    };

    /**
     * Remove a complete row level drilldown
     * @param vm View Model to update
     */
    this.drillUpRowLevel = function (vm) {
        CubeConfigService.selectedCube.removeRowLevelDrillDowns = true;
        CubeConfigService.rowLevelDrillDownIndex--;
        this.init(vm);
    };

    this.slice = function (vm, slices) {
        CubeConfigService.selectedCube.slices = slices;
        this.init(vm);
    };

    this.refresh = function (vm) {
        CubeConfigService.columnLevelDrillDownIndex = 0;
        CubeConfigService.rowLevelDrillDownIndex = 0;
        CubeConfigService.selectedCube.slices = {};
        CubeConfigService.selectedCube.drillDowns = [];
        CubeConfigService.selectedCube.newDrillDowns = [];
        CubeConfigService.selectedCube.removeDrillDowns = [];
        this.init(vm);
    };

    /**
     * Can we create a cube
     * @returns {*|null}
     */
    this.canCreateCube = function () {
        return CubeConfigService.selectedCube
    };

    /**
     * Send the cube as an email
     * @returns {*}
     */
    this.sendMail = function () {
        var tmpscope = {};
        return dataGen.postAsForm(tmpscope, {cube: CubeConfigService.selectedCube}, "/monitor/cube/mail").then(function () {
            ToastService.openStandardToast(tmpscope.trns.success);
        });
    };

    /**
     * save the cube
     * @returns {*}
     */
    this.save = function () {
        var tmpscope = {};
        return dataGen.postAsForm(tmpscope, {cube: CubeConfigService.selectedCube}, "/monitor/cube/save").then(function () {
            var optionsOrPreset = $mdToast.simple().textContent(tmpscope.trns.success);
            optionsOrPreset.position('bottom right');
            $mdToast.show(optionsOrPreset);
            cubeMenu.refreshCubes();
        });
    }

}
